import React, { useEffect, useState } from 'react';
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css";
import { imgUrlConverter, settings } from '../../util'

export const PopularPackage = trackWindowScroll(({ firstPackageName, packageItems, hsPopularPackage, popularPackageProdRefCode, scrollPosition, isDegreeSelected }) => {

    const [finalArray, setFinalArray] = useState([]);

    useEffect(() => {
        let tempArr = [];
        packageItems?.length > 0 && packageItems.map((packageItem) => {
            if(packageItem?.personalizedAnnouncementItems?.length>0) {
                packageItem.personalizedAnnouncementItems.map((paItem) => {
                    if(popularPackageProdRefCode===paItem?.prodRefcode) {
                        tempArr.push(paItem);
                    }
                })
            } else {
                tempArr.push(packageItem);
            }
        })
        setFinalArray(tempArr);
    }, [packageItems])

    const handleScroll = () => {
        const slickSliderPrevButton = document?.getElementsByClassName("slick-prev") && document.getElementsByClassName("slick-prev")[0]
        if(slickSliderPrevButton) {
            slickSliderPrevButton.click();
            if (slickSliderPrevButton.classList.contains('slick-disabled')) {
                removeScrollEvent();
            }
        }
    }
    
    const addScrollEvent = () => {
        window.addEventListener('scroll', handleScroll);
    }

    const removeScrollEvent = () => {
        window.removeEventListener('scroll', handleScroll);
    }

    useEffect(() => {
        addScrollEvent();
        return () => removeScrollEvent();
    },[])

    if (packageItems?.length > 0 && isDegreeSelected) {
        return (
            <div className="product-categories">
                <div className="row mb-3 mx-2">
                    <div className="container-fluid">
                        <h2>{firstPackageName} {hsPopularPackage.title}</h2>
                        <Slider {...settings} className="carousel">
                            {finalArray?.length > 0 && finalArray.map((packageItem, key) =>
                                <div key={key}>
                                     <LazyLoadImage src={imgUrlConverter(packageItem?.imageUrl || hsPopularPackage?.imageUrl, "product_md")} alt={packageItem?.displayName} scrollPosition={scrollPosition} onError={(e) => e.target.src = hsPopularPackage?.imageUrl}/>
                                    <div className="packageItems-productName">
                                        <div className='workBreak fontSizeXS' title={packageItem?.displayName+"."}>{packageItem?.displayName}</div>
                                        <i className='fas fa-info-circle' onClick={() => {
                                            document
                                                .getElementById('long-name-popup-' + key)
                                                .classList.remove('d-none');
                                        }}></i>
                                    </div>
                                    <div
                                        className='long-desc-popup d-none'
                                        id={'long-name-popup-' + key}>
                                        <button aria-label="close"
                                            className='close' title="close"
                                            onClick={() => {
                                                document
                                                    .getElementById('long-name-popup-' + key)
                                                    .classList.add('d-none');
                                            }}>
                                            <i className='fas fa-times'></i>
                                        </button>
                                        <div className='long-desc-popup-text'>{packageItem?.displayName}</div>
                                    </div>
                                </div>
                            )}
                        </Slider>
                    </div>
                </div>
            </div>
        )
    } else {
        return <></>
    }
})